export default "__VITE_ASSET__BpZ$NjkA__"